import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_COORDINATOR_APPEAL_SEND_PAYMENT_LINK_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorAppealSendPaymentLink = ({onSuccess, onError}: Input = {}) => {
  const postCoordinatorAppealSendPaymentLink = async (uuid: string) => {
    const res = await axiosClient.post<void>(POST_COORDINATOR_APPEAL_SEND_PAYMENT_LINK_URL(uuid));

    return res.data;
  };

  return useCustomMutation(postCoordinatorAppealSendPaymentLink, {
    onSuccess,
    onError,
  });
};
